export default __webpack_public_path__ + "static/media/quotes_end.b545dfea.svg";